import { Api } from './api';
import endpoints from '../utils/endpoints';
import { Iauth } from './types';
import { notificationError } from './notification';

export const logIn = async (params: Iauth) => {
  let res = {
    images: [],
    message: "",
    name: "",
    portal: "",
    return: false,
    version: "",
    welcome: "",
    affiliation: ""
  };

  await Api.post(endpoints.logIn, params).then((response) => {
    res = response.data
    if(res.return === false && res.message) {
      notificationError(res.message)
    }
  }).catch((err: string) => {
    notificationError(err)
  })
  return res
}

export const logOut = async () => {
  let res = {return: false};
  await Api.get(`${endpoints.logOut}`).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError(err)
  })
  return res
}

export async function verifySessionToken(): Promise<boolean> {
  let res = false
  await Api.get(endpoints.getFooter + "?date="+ Date.now().toString()).then((response) => {
    if(!response || response.data.return === false) return 
    if(response && response.data.return === true) {
      res = response.data.return
    }
  }).catch((err: string) => {
    return res
  })
  return res
}